/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Voice_ItalianInputs */

const en_onboarding_voice_italian = /** @type {(inputs: Onboarding_Voice_ItalianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Italian`)
};

const es_onboarding_voice_italian = /** @type {(inputs: Onboarding_Voice_ItalianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Italiano`)
};

/**
* | output |
* | --- |
* | "Italian" |
*
* @param {Onboarding_Voice_ItalianInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_voice_italian = /** @type {((inputs?: Onboarding_Voice_ItalianInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Voice_ItalianInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_voice_italian(inputs)
	return en_onboarding_voice_italian(inputs)
});